import { Alert, AlertTitle, Button } from '@mui/material'
import { useState } from 'react'
import ContentDialog from '../../Dialogs/ContentDialog'
import ConnectionInstructions from '../../../pages/Products/NewProduct/SocialMediaChoose/ConnectionInstructions'
import {
  CommunityIntegrationStatus,
  TProductSocialMedia,
} from '../../../core/types/Product'

const ProductCommunityStatus = ({
  code,
  communityPlatformType,
  communityIntegrationStatus,
}: {
  code: string
  communityPlatformType?: TProductSocialMedia | null
  communityIntegrationStatus?: CommunityIntegrationStatus | null
}) => {
  if (
    !communityPlatformType ||
    communityPlatformType === TProductSocialMedia.Instagram
  ) {
    return <></>
  }

  if (communityIntegrationStatus === CommunityIntegrationStatus.Active) {
    return <></>
  }

  const [open, setOpen] = useState(false)

  const handleChangeOpen = () => {
    setOpen(true)
  }

  const handleChangeClose = () => {
    setOpen(false)
  }

  const handleChangeRefresh = () => {
    setOpen(false)
    window.location.reload()
  }

  return (
    <>
      {communityIntegrationStatus ===
        CommunityIntegrationStatus.PendingSetup && (
        <Alert
          variant="outlined"
          severity="warning"
          action={
            <Button
              color="inherit"
              size="small"
              sx={{ textTransform: 'none' }}
              onClick={handleChangeOpen}
            >
              Configurar integração
            </Button>
          }
          sx={{ mb: 1 }}
        >
          <AlertTitle>
            Ainda falta concluir a integração com sua comunidade do Telegram.
          </AlertTitle>
          Toque em "Configurar integração" e finalize o processo em poucos
          passos.
        </Alert>
      )}

      {communityIntegrationStatus === CommunityIntegrationStatus.Error && (
        <Alert variant="outlined" severity="error" sx={{ mb: 1 }}>
          <AlertTitle>Erro ao conectar com o Telegram.</AlertTitle>
          Verifique as permissões da sua comunidade e tente novamente. Se o
          problema persistir, entre em contato com o suporte.
        </Alert>
      )}

      <ContentDialog
        open={open}
        onClose={handleChangeClose}
        buttons={[
          {
            title: 'Atualizar',
            type: 'positive',
            onClick: handleChangeRefresh,
          },
        ]}
      >
        <ConnectionInstructions code={code} />
      </ContentDialog>
    </>
  )
}

export default ProductCommunityStatus
